<ion-list *ngIf="placements" class="ion-no-margin ion-no-padding">
    <ng-content></ng-content>
    <jobs-placements-list-item-placement
        *ngFor="let placement of placements; trackBy: trackByID; index as i"
        [index]="i"
        [item]="placement"
        (selectEvent)="select($event)">
    </jobs-placements-list-item-placement>
</ion-list>
